export const MAX_LEGAL_COMPANY_NAME_LENGTH = 100

export const VALID_AUSTRALIA_IDENTIFICATION_NUMBER_REGEXP = /^[0-9]{9}$/
